import { observable, computed, action, IObservableArray } from "mobx";

import { DocumentStoreImpl } from "./DocumentStore";
import { WizardStore, IWizardStore } from "./AppStore";
import { Strings } from "../Stores/StringsStore";

export class DocumentPrivilegesWizardStore extends WizardStore implements IWizardStore {

	constructor(public documentStore: DocumentStoreImpl) {
		super();
	}


	/**
  * Open the wizard for adding privileges to a documents.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.documentEdit.addPrivilegesCaption;
		this.wizardInformation = Strings.documentManagement.documentEdit.addPrivilegesText;
		this.documentStore.addPrivilegesMode = true;
		this.isOpen = true;
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.documentStore.saveSelectedPrivilege();
		this.isOpen = false;
		this.documentStore.addPrivilegesMode = false;
		this.onConfirmExternal();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.documentStore.addPrivilegesMode = false;
	}

}